import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { useParams, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useQuery } from "@apollo/client";
import { TARIFF_TAGS_QUERY, PROVIDER_AVAILABILITY_OPERATOR_QUERY } from "Services/queries";
import { sendMetriks } from "Services/sendMetriks";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import smoothScrollTo from "Helpers/Scroll";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import RecentlyConnectedTariffsContainer from "Containers/RecentlyConnectedTariffsContainer";
import TopProviderContainer from "Containers/TopProviderContainer";
import { PaddingTop } from "ComponentsUI/Spacings";
import NoFindTariffs from "ComponentsUI/NoFindTariffs";
import { RedirectPagination } from "ComponentsUI/Redirects";
import TarifficationTagsList from "../tarifficationTagsList";
import { Container } from "reactstrap";
import { SeoBlockContainer } from "Containers/SeoBlock";

const ProviderRatesTag = (props) => {
	const routeParams = useParams();
	useEffect(() => {
		const {
			ApplicationModel: { providerModel },
		} = props;
		if (providerModel.visibleTab !== "provider_tab_tariffs") {
			providerModel.changeTab("provider_tab_tariffs");
		}
	}, []);

	useEffect(() => {
		const {
			providerForCard: { vip_provider },
		} = props;
		if (window) {
			smoothScrollTo(0, 700);
		}
		if (vip_provider) {
			sendMetriks("PROVIDER_VIP");
		}
	}, [props.match.params.tagCode]);

	useEffect(() => {
		sendYandexMetrika();
	}, [props.match.params.tagCode]);

	const sendYandexMetrika = () => {
		try {
			sendMetriks("LOAD_TAG_PAGE_RATES_PROVIDER");
		} catch (e) {
			console.warn("Error sendMetrica", e);
		}
	};

	const canonical = () => {
		const { tagCode } = routeParams;
		const {
			ApplicationModel: { siteConfig },
		} = props;

		const location = generateUrl(configRouters.ProviderRatesTags.route, {
			regionUrl: props.match.params.regionUrl,
			providerName: props.match.params.providerName,
			tagCode: tagCode,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	const {
		ApplicationModel: { text },
		match,
		providerForCard,
		route,
	} = props;
	let isMobile = props.ApplicationModel.windowSizeModel.windowSizes.xs;

	const tariffsTagsQuery = useQuery(TARIFF_TAGS_QUERY, {
		variables: {
			filter: `region.url=${match.params.regionUrl}&provider.url_name=${match.params.providerName}`,
			providerPage: true,
		},
		skip: !match.params.regionUrl || !match.params.providerName,
	});

	const operatorTagQuery = useQuery(PROVIDER_AVAILABILITY_OPERATOR_QUERY, {
		variables: {
			global_id: providerForCard?.global?.id || 0,
			url_region: match.params.regionUrl,
		},
		skip: !match.params.regionUrl || !providerForCard || !providerForCard.global,
	});

	let tariffTags = tariffsTagsQuery?.data?.tariffsTags?.data;
	let operatorTag = operatorTagQuery?.data?.providerAvailabilityOperator;
	if (match.params.page === "1") {
		return <RedirectPagination />;
	}
	return (
		<>
			{canonical()}
			<PaddingTop>
				<div
					style={{
						display: "block",
					}}
				>
					{!!providerForCard?.info?.cnt_tariffs && (
						<SeoBlockHOC route={route} placeText="TarifficationTags">
							<TarifficationTagsList
								providerForCard={providerForCard}
								tariffTags={tariffTags}
								operatorTag={operatorTag}
								isProviderRatesTags={true}
								isMobile={isMobile}
								skipLayout={true}
							/>
						</SeoBlockHOC>
					)}
					{!providerForCard?.info?.cnt_tariffs && (
						<>
							<NoFindTariffs text={text} />
							<SeoBlockHOC route={route} placeText="TopProvider">
								<TopProviderContainer />
							</SeoBlockHOC>
							<RecentlyConnectedTariffsContainer {...props} isRates={true} skipLayout={true} />
						</>
					)}
				</div>
				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock1" bgText={true} />
					<SeoBlockContainer route={route} placeText="SeoBlock2" bgText={true} />
				</Container>
			</PaddingTop>
		</>
	);
};

export default withRouter(
	withDefaultParams(inject("ApplicationModel")(observer(ProviderRatesTag)))
);
